<template>
	<b-modal
		id="vmachine"
		size="lg"
		centered
		hide-footer
		hide-header
		no-close-on-backdrop
		:no-close-on-esc="true"
	>
		<div
			class="newmodalheadings mt-3 d-flex align-items-center justify-content-center"
		>
			Alert !
		</div>
		<div @click="$bvModal.hide('vmachine')" class="modalcloseicon pointer">
			<img
				class="rotate-on-hover"
				src="../../assets/newimgs/closeicon.svg"
				alt=""
			/>
		</div>
		<div
			class="d-flex flex-column align-items-center justify-content-center mt-4 mb-4"
		>
			<div><img src="../../assets/newui-img/alertimage.svg" alt="" /></div>
			<div class="newui-modal-bodytxt mt-4">
				"Please stop the virtual machine before starting the test."
			</div>
			<div class="bluebtns mt-5">
				<b-button
					class="mr-1 px-5"
					variant="primary"
					@click="$bvModal.hide('vmachine')"
					>Okay</b-button
				>
			</div>
		</div>
	</b-modal>
</template>
<script>
export default {
	name: "VmModal",
};
</script>
